import {createRoot} from 'react-dom/client';
import React from 'react';

class Styles {
  constructor() {
    let AlgoliaListingPages;

    const catid = $('.pc-Styles').attr('data-catid');
    const catDefaultQuoteQty = parseInt(
      document.querySelector('meta[property="category-default-quote-qty"]')
        .content,
      10
    );
    ProductCatalog.gtmEvent('algoliaTest', 'algoliaTest', catid || '');
    AlgoliaListingPages =
      require('../../components/AlgoliaListingPages').default;
    const navDomNode = document.getElementById('algolia-styles-loading');
    const navRoot = createRoot(navDomNode);
    navRoot.render(
      <AlgoliaListingPages
        category_id={
          document.querySelector('meta[property="category-id"]').content
        }
        category_name={
          document.querySelector('meta[property="category-name"]').content
        }
        controller={
          document.querySelector('meta[property="controller"]').content
        }
        action={document.querySelector('meta[property="action"]').content}
        rails_env={document.querySelector('meta[property="rails_env"]').content}
        filter_groups={document
          .querySelector('meta[property="filter_groups"]')
          .content.split(' ')}
        subcategory_navigation={JSON.parse(
          document.querySelector('meta[property="subcategory_navigation"]')
            .content || '{}'
        )}
        default_quote_qty={
          isNaN(catDefaultQuoteQty) || catDefaultQuoteQty <= 0
            ? null
            : catDefaultQuoteQty
        }
        current_user_internal={
          document.querySelector('meta[property="current_user_internal"]')
            .content === 'true'
        }
        ydh_settings={JSON.parse(
          document.querySelector('meta[property="ydh_settings"]').content ||
            '{}'
        )}
        first_image={document
          .getElementsByClassName('pc-ProductCard-imagePrimary')[0]
          ?.getAttribute('src')}
      />
    );
  }

  el() {
    return $('.pc-Styles');
  }

  isInternal() {
    return (
      document.querySelector('meta[property="current_user_internal"]')
        .content === 'true'
    );
  }

  isPresent() {
    return this.el().length > 0;
  }

  cards() {
    return this.el().find('.pc-ProductCard:not(.pc-PromoProductCard)');
  }

  products() {
    return this.el().find('.pc-Styles-products');
  }

  isSearchResults() {
    return this.el().hasClass('is-searchResults');
  }

  isFilteredColor() {
    return this.products().hasClass('is-filteredColor');
  }

  isFilteredNoMinimum() {
    return this.products().hasClass('is-filteredNoMinimum');
  }

  isCustom() {
    return this.products().hasClass('is-Custom');
  }

  filteredColorNames() {
    return this.products().data('colors');
  }
}

ProductCatalog.Styles = new Styles();
StyleBitz.Utils.pageLoaded(() => {
  const id = ProductCatalog.Styles.el().data('catid');
  if (id === 205) {
    return $('.sb-PageToolbar-message').text(
      'Custom T-shirts & More and Fast Shipping'
    );
  }
});
